<template>
	<li>
		<a class="" v-bind:href="trigger +'?' + canonical_querystring">
			{{ $t("classes." + classid )}}.
			{{ location_title | separator }}
			{{ type_title | separator }}
			{{ price_formatted | labelbefore($t('searches.priceto')) }}
			{{ furnished | trilean($t('searches.furnished'), $t('searches.unfurnished')) | separator }}
			{{ newdev | trilean($t('searches.newdev_offplan'), $t('searches.newdev_resale')) | separator }}
			{{ beds | labelafter($t('searches.beds')) | separator}}
			{{ baths | labelafter($t('searches.baths')) | separator}}
			{{ people | labelafter($t('searches.people')) | separator}}
			{{ feats | labelbefore($t('searches.features')) | separator}}
		</a>
		<div class="c-saved-searches-btns">
			<button v-on:click.prevent="remove" class="c-saved-searches-btn c-icon-link">
				<icon name="close" />
				{{$t("searches.button.remove")}}
			</button>
			<button 
			 	class="c-saved-searches-btn c-icon-link"
		  		v-clipboard:copy="shareurl" 
		  		v-clipboard:success="onCopySuccess"
		  		v-clipboard:error="onCopyError"
		  		>
		  		<icon name="link" />
				{{$t("searches.button.share")}}
		  	</button>
		</div>
	</li>
</template>

<script>
	import Icon from './icon.vue';
	export default {
	  name: 'favourite',
		components: {Icon},
	  filters: {
	  	labelafter(value, labelText){
	  		return value.length ? value + ' ' + labelText : '';
	  	},
	  	labelbefore(value, labelText){
	  		return value.length ? labelText + ' ' + value : '';
	  	},
	  	boolean(value, trueText, falseText){
	  		return value ? trueText || 'Yes' : falseText || 'No';
	  	},
	  	trilean(value, trueText, falseText){
	  		if(value.length){
	  			return value == "true" ? trueText || 'Yes' : falseText || 'No';
	  		}
	  		return '';
	  	},
	  	separator(value, sep){
	  		return value + (value.length ? (sep || '.') + ' ' : '');
	  	}
	  },
	  props: {
	  	canonical_querystring: String,
	  	hash: String,
	  	location_title: String,
			classid: String,
			furnished: String,
			newdev: String,
			type_title: String,
			priceto: [Number,String],
			beds: String,
			baths: String,
			people: String,
			features: String,
			trigger: String
	  },
	  computed: {
	  	shareurl: function(){
	  		// Creates a search link
	  		return this.trigger
	  			+ '?'
	  			+ encodeURI(this.canonical_querystring)
	  		;
	  	},
	  	price_formatted(){
	  		if(this.priceto == 0) return '';
	  		return this.$n(this.priceto, 'currency');
	  	},
	  	feats(){
	  		if(!this.features.length) return '';
	  		var feats = this.features.split(',');
				return feats.map(function(feat){
					return this.$t('features.' + feat);
				}, this).join(', ');
	  	}
	  },
	  data () {return {}}, 
	  methods: {
			remove: function(){
				// Call the remove event on the parent Vue component
	  		this.$emit('remove', this.hash);
			},
			onCopySuccess(e){
	  		this.$emit('openModal',{
	  			title:this.$t('searches.copymodal.title'),
         	body:this.$t('searches.copymodal.bodyauto')
         });
	  		this.$emit('logCopy', this.shareurl);
	  	},
	  	onCopyError(){
	  		this.$emit('openModal',{
         title:this.$t('searches.copymodal.title'),
         body:this.$t('searches.copymodal.bodymanual'),
         code:this.shareurl
       	});
	  	}
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/search.vue